import { render, staticRenderFns } from "./TSZ_Usuarios_Externos.vue?vue&type=template&id=65f60b8b&scoped=true&"
import script from "./TSZ_Usuarios_Externos.vue?vue&type=script&lang=js&"
export * from "./TSZ_Usuarios_Externos.vue?vue&type=script&lang=js&"
import style0 from "./TSZ_Usuarios_Externos.vue?vue&type=style&index=0&id=65f60b8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f60b8b",
  null
  
)

export default component.exports